import { ref } from "vue";

const callIdState = ref("");

export function setCallId(callId: string) {
  callIdState.value = callId;
}

export function getCallId() {
  return callIdState.value;
}
